import { History } from "history";

import {
  ADD_SCHOOL,
  ADD_SCHOOL_ERROR,
  ADD_SCHOOL_SUCCESS,
  AddSchoolAction,
  AddSchoolErrorAction,
  AddSchoolSuccessAction,
  DELETE_SCHOOL,
  DELETE_SCHOOL_CONSENT,
  DELETE_SCHOOL_ERROR,
  DELETE_SCHOOL_SUCCESS,
  DeleteSchoolAction,
  DeleteSchoolConsentAction,
  DeleteSchoolErrorAction,
  DeleteSchoolSuccessAction,
  GET_SCHOOL,
  GET_SCHOOLS,
  GET_SCHOOLS_ERROR,
  GET_SCHOOLS_SUCCESS,
  GET_SCHOOL_ERROR,
  GET_SCHOOL_SELECT_LIST,
  GET_SCHOOL_SELECT_LIST_ERROR,
  GET_SCHOOL_SELECT_LIST_SUCCESS,
  GET_SCHOOL_SUCCESS,
  GetSchoolAction,
  GetSchoolErrorAction,
  GetSchoolSelectListAction,
  GetSchoolSelectListErrorAction,
  GetSchoolSelectListSuccessAction,
  GetSchoolSuccessAction,
  GetSchoolsAction,
  GetSchoolsErrorAction,
  GetSchoolsSuccessAction,
  RESET_SCHOOL_SELECT_LIST,
  ResetSchoolSelectListAction,
  UPDATE_SCHOOL,
  UPDATE_SCHOOL_ERROR,
  UPDATE_SCHOOL_SUCCESS,
  UpdateSchoolAction,
  UpdateSchoolErrorAction,
  UpdateSchoolSuccessAction,
} from "./actionTypes";
import {
  CreateSchoolRequest,
  SchoolDto,
  PaginateQuery,
  UpdateSchoolRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Schools

export const getSchools = (
  request: PaginateQuery,
  history: History
): GetSchoolsAction => {
  return {
    type: GET_SCHOOLS,
    payload: { request, history },
  };
};

export const getSchoolsSuccess = (
  response: Paginated<SchoolDto>
): GetSchoolsSuccessAction => {
  return {
    type: GET_SCHOOLS_SUCCESS,
    payload: response,
  };
};

export const getSchoolsError = (error: any): GetSchoolsErrorAction => {
  return {
    type: GET_SCHOOLS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get School

export const getSchool = (id: string, history: History): GetSchoolAction => {
  return {
    type: GET_SCHOOL,
    payload: { id, history },
  };
};

export const getSchoolSuccess = (
  response: SchoolDto
): GetSchoolSuccessAction => {
  return {
    type: GET_SCHOOL_SUCCESS,
    payload: response,
  };
};

export const getSchoolError = (error: any): GetSchoolErrorAction => {
  return {
    type: GET_SCHOOL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get School Select List

export const resetSchoolSelectList = (): ResetSchoolSelectListAction => {
  return {
    type: RESET_SCHOOL_SELECT_LIST,
    payload: null,
  };
};

export const getSchoolSelectList = (
  governorateId: string,
  cityId: string,
  history: History
): GetSchoolSelectListAction => {
  return {
    type: GET_SCHOOL_SELECT_LIST,
    payload: { governorateId, cityId, history },
  };
};

export const getSchoolSelectListSuccess = (
  response: SelectListDto[]
): GetSchoolSelectListSuccessAction => {
  return {
    type: GET_SCHOOL_SELECT_LIST_SUCCESS,
    payload: response,
  };
};

export const getSchoolSelectListError = (
  error: any
): GetSchoolSelectListErrorAction => {
  return {
    type: GET_SCHOOL_SELECT_LIST_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add School

export const addSchool = (
  request: CreateSchoolRequest,
  history: History
): AddSchoolAction => {
  return {
    type: ADD_SCHOOL,
    payload: { request, history },
  };
};

export const addSchoolSuccess = (): AddSchoolSuccessAction => {
  return {
    type: ADD_SCHOOL_SUCCESS,
    payload: null,
  };
};

export const addSchoolError = (error: any): AddSchoolErrorAction => {
  return {
    type: ADD_SCHOOL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update School

export const updateSchool = (
  id: string,
  request: UpdateSchoolRequest,
  history: History
): UpdateSchoolAction => {
  return {
    type: UPDATE_SCHOOL,
    payload: { id, request, history },
  };
};

export const updateSchoolSuccess = (): UpdateSchoolSuccessAction => {
  return {
    type: UPDATE_SCHOOL_SUCCESS,
    payload: null,
  };
};

export const updateSchoolError = (error: any): UpdateSchoolErrorAction => {
  return {
    type: UPDATE_SCHOOL_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete School

export const deleteSchoolConsent = (id: string): DeleteSchoolConsentAction => {
  return {
    type: DELETE_SCHOOL_CONSENT,
    payload: id,
  };
};

export const deleteSchool = (
  id: string,
  history: History
): DeleteSchoolAction => {
  return {
    type: DELETE_SCHOOL,
    payload: { id, history },
  };
};

export const deleteSchoolSuccess = (): DeleteSchoolSuccessAction => {
  return {
    type: DELETE_SCHOOL_SUCCESS,
    payload: null,
  };
};

export const deleteSchoolError = (error: any): DeleteSchoolErrorAction => {
  return {
    type: DELETE_SCHOOL_ERROR,
    payload: error,
  };
};

//#endregion
